import React, { Component } from 'react'
import { CommonValidationMessages } from '../../../utils/Messages';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import { TaxStructureMasterPopup } from './TaxStructureMasterTable';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import moment from 'moment';
import MasterEntryServices from '../../../services/axiosServices/apiServices/MasterEntryServices';
import { permission } from '../../../utils/enums/ValidationMessage';
//import { name } from '@azure/msal-angular/packageMetadata';

export default class TaxStructureMaster extends Component {
    constructor(props) {
        super(props)
        this.accountTransactionServices = new AccountTransactionServices();
        this.masterEntryServices = new MasterEntryServices();
        this.SwalServices = new SwalServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            isModalOpen: false,
            rowData: [],
            colDefs: [],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            taxObject: {
                idTaxStructure: 0,
                updateStatus: 0,
                code: "",
                date: "",
                name: "",
                sgst: "",
                cgst: "",
                igst: "",
                e_Date: null,
                accountheadListForInputGst: [],
                accountheadListForOutputGst: [],
                idAccountHeadForInputGst: 0,
                idAccountHeadForOutputGst: 0,
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                date: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "date"
                        ),
                    },
                ],
            },
        }
    }

    handleChangeFroDropdown = (event, name) => {
        //debugger;
        let value = event.value;
        let details = this.state.taxObject;
        details[name] = value;
        this.setState({ taxObject: details });
    }

    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error("You don't have permission to add record.");
            return;
        }
        this.setState({ isModalOpen: true }, () => {
            this.resetDetailsFields();
            // this.getMasterExpenseAccGroupCount();
        })
    };

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        this.getTaxStructureSelectbyID(event.data.idTaxStructure);
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState
        });
    };

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.taxObject,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    setOpenModel = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };
    closePopup = () => {
        this.setState({ isModalOpen: false, });
    };

    handleChange = (event, name) => {
        let value = event.target.value;
        let details = this.state.taxObject;
        details[name] = value;
        this.setState({ taxObject: details });
    }

    getPinnedWidth = (key) => {
        // const pinnedCol = {
        //     "idCashWithdraw": window.innerWidth * 0.06,
        //     "sR.No": window.innerWidth * 0.04,
        //     "employeeName": window.innerWidth * 0.18,
        // }
        // return pinnedCol[key]
    }

    resetDetailsFields = () => {
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        let taxObject = this.state.taxObject;
        taxObject.idTaxStructure = 0;
        taxObject.updateStatus = 0;
        taxObject.code = "";
        taxObject.date = "";
        taxObject.name = "";
        taxObject.sgst = "";
        taxObject.cgst = "";
        taxObject.igst = "";
        taxObject.e_Date = "";
        taxObject.e_Date = null;
        taxObject.idAccountHeadForInputGst = 0;
        taxObject.idAccountHeadForOutputGst = 0;
        this.setState({
            taxObject: taxObject, validState: validState
        }, () => {
            this.getMasterDropdownData();
        });
    }

    componentDidMount = () => {
        let prop = getAuthProps()
        //debugger
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser }, () => {
                this.procSelectAllRecordsSP();
                this.getSalaryToBankDropdown();
            });
        } else {
            // window.location.href = "/Login";
        } setTimeout(() => {
            //this.removeDefaultBorders();
        }, 100);
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Tax Structure Master",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
            //idFinancialYear : null,
            //idPlant : 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                //debugger;
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key) !== undefined ? this.getColumnWidth(key) : window.innerWidth * 0.06,
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            hide: ["idTaxStructure"].includes(key) ? true : false,
                            width: this.getPinnedWidth(key),
                            valueGetter: (params) => params.data[key],
                            valueFormatter: key.includes("date")
                                ? (params) => {
                                    if (!params.value) return "";
                                    return moment(params.value).format("DD-MM-YYYY");
                                }
                                : undefined,
                            //pinned: ["idBank", "sR.No", "employeeName"].includes(key) ? "left" : null,
                        }));
                        //const priorityColumn = "bankName"; // Replace with the actual column name
                        //const pinnedColumns = dynamicColDefs.filter(col => col.pinned === "left");
                        //const priorityColDef = dynamicColDefs.find(col => col.field === priorityColumn);
                        //const otherColumns = dynamicColDefs.filter(col => col.field !== priorityColumn && !col.pinned);

                        // const updatedColDefs = [
                        //   ...pinnedColumns,
                        //   ...(priorityColDef ? [priorityColDef] : []),
                        //   ...otherColumns,
                        // ];
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs, //updatedColDefs,
                            caption: "Tax Structure Master",
                            colName: colName
                        }, () => {
                            //this.procSelectAllRecord2GridviewSP(id, "Advance Withdraw");
                            //this.getAllDropdownForEmployeeMaster();
                            this.setPermissions(permissions);
                        });
                    } else {
                        this.setPermissions(permissions);
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                            this.gridApi.showNoRowsOverlay();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    getColumnWidth = (key) => {
        const colwidth = {
            "sR.No": window.innerWidth * 0.05,
            "taxStructureName": window.innerWidth * 0.2,
            "date": window.innerWidth * 0.1,
            "sgst": window.innerWidth * 0.06,
            "cgst": window.innerWidth * 0.06,
            "igst": window.innerWidth * 0.06,
            "inputGst": window.innerWidth * 0.12,
            "outputGst": window.innerWidth * 0.12,
        }
        return colwidth[key]
    }

    getMasterDropdownData = () => {
        let request = {
            idCompany: this.state.idCompany,
        }
        this.masterEntryServices.getMasterDropdownData(request).then((response) => {
            //debugger
            if (response.statusCode == 200 && response.responseItem !== null) {
                let allData = response.responseItem.responseContent;
                let data = this.state.taxObject;

                let count = allData.filter(item => item.identitys === 'CountTaxStructure');
                data.code = count[0].count > 0 ? (count[0].count + 1) : (0 + 1);

                this.setState({
                    taxObject: data
                });
            } else {
                //this.usp_Master_EmployeeSelect()
            }
        });
    }

    getSalaryToBankDropdown = () => {
        let request = {
            idCompany: this.state.idCompany,
            idFinancialYear: 2
        }
        this.accountTransactionServices.getSalaryToBankDropdown(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let dropDowndata = response.responseItem.responseContent;
                let data = this.state.taxObject;
                data.accountheadListForInputGst = dropDowndata.filter(item => item.source === 'Master_AccountHead');
                data.accountheadListForOutputGst = dropDowndata.filter(item => item.source === 'Master_AccountHead');
                this.setState({
                    taxObject: data
                });
            }
        });
    }

    submit = () => {
        const isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            let details = this.state.taxObject;
            let requestData = {
                idTaxStructure: details.idTaxStructure,
                taxStructureNo: details.code,
                taxStructureName: details.name,
                date: (details.date && details.date !== 'Invalid date') ? details.date : new Date().toISOString(),
                sgst: details.sgst,
                cgst: details.cgst,
                igst: details.igst,
                idCompany: this.state.idCompany,
                e_Date: details.e_Date ? details.e_Date : new Date().toISOString(),
                isUpdated: details.updateStatus === 1 ? true : false,
                updatedDate: details.updateStatus === 1 ? new Date().toISOString() : "",
                isDeleted: false,
                deletedDate: null,
                idAccountHeadForInputGst: details.idAccountHeadForInputGst,
                idAccountHeadForOutputGst: details.idAccountHeadForOutputGst,
            };
            this.masterEntryServices.submitTaxStructureMaster(requestData)
                .then((response) => {
                    if (response.statusCode == 200 && response.responseItem !== null) {
                        let dynamicData = response.responseItem.responseContent;
                        if (dynamicData !== null) {
                            if (dynamicData.errorType === 'Exists') {
                                this.SwalServices.Warning(dynamicData.errorMessage);
                            } else {
                                if (this.state.taxObject.updateStatus === 1) {
                                    this.SwalServices.Success("Updated successfully.");
                                } else {
                                    this.SwalServices.Success("Saved successfully.");
                                }
                                this.resetDetailsFields();
                                // Call resetFields here after submission
                                this.setState(
                                    { isModalOpen: false },
                                    () => {
                                        this.procSelectAllRecordsSP(); // Fetch latest records
                                    }
                                );
                            }
                        } else {
                            this.procSelectAllRecordsSP();
                        }
                    } else {
                        this.setState(
                            { isModalOpen: false },
                            () => {
                                this.SwalServices.Error(response.message);
                                this.procSelectAllRecordsSP(); // Fetch latest records
                            }
                        );
                    }
                });
        }
    };

    getTaxStructureSelectbyID = (id) => {
        this.masterEntryServices.getTaxStructureSelectbyID(id).then((response) => {
            //debugger
            if (response.statusCode == 200 && response.responseItem !== null) {
                let res = response.responseItem.responseContent[0];
                let data = this.state.taxObject;
                data.idTaxStructure = res.idTaxStructure;
                data.updateStatus = 1;
                data.code = res.taxStructureNo;
                data.date = moment(res.date).format('YYYY-MM-DD');
                data.name = res.taxStructureName;
                data.sgst = res.sgst;
                data.cgst = res.cgst;
                data.igst = res.igst;
                data.e_Date = res.e_Date;
                data.idAccountHeadForInputGst = res.idAccountHeadForInputGst;
                data.idAccountHeadForOutputGst = res.idAccountHeadForOutputGst;
                this.setState({
                    taxObject: data,
                    isModalOpen: true
                });
            }
        });
    }

    render() {
        return (
            <div className='tax-structure-master'>
                <div className='data-display'>
                    <div className='data-display-inner relative'>
                        <ButtonGrp buttons={['add', 'print', 'delete']}
                            onClickHandlers={{
                                add: () => this.openPopUpForAddingItem(),
                                // update: () => this.openPopUpForUpdateItem(),
                                print: this.handlePrint,
                                delete: this.handleDelete,
                            }}
                        />
                        <TaxStructureMasterPopup
                            isModalOpen={this.state.isModalOpen}
                            setOpenModel={this.setOpenModel.bind(this)}
                            taxObject={this.state.taxObject}
                            handleChange={this.handleChange.bind(this)}
                            close={this.closePopup.bind(this)}
                            submit={this.submit.bind(this)}
                            handleChangeFroDropdown={this.handleChangeFroDropdown.bind(this)}
                            validState={this.state.validState}
                        />
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 156px)" }}>
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Tax structure master</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    onGridReady={this.onGridReady}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
